import { Container, Box, Typography, Link } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Fab from '@mui/material/Fab';
import { useTranslation } from 'react-i18next';
import CartAdder, { CartAdderRef } from '../cart/CartAdder';
import { useRestaurantData } from '../../provider/RestaurantDataContext';
import { useParams } from 'react-router-dom';
import { useItemContext } from '../../provider/ItemContext';

export type CenteredProps = {
    center?: boolean;
    children?: React.ReactNode | React.ReactNode[];
    style?: React.CSSProperties;
    maxWidth?: boolean;
}

export default function Centered({ center = true, children, style, maxWidth = true }: CenteredProps) {
    const [isScrolledToBottom, setIsScrolledToBottom] = useState(false);
    const [oldHeight, setOldHeight] = useState(0);
    const [moveButton, setMoveButton] = useState(false);
    const { item } = useItemContext();
    const params = useParams();
    const { restaurantData: { qrMenuProperties, license }, table, token, sessionId, expired, live } = useRestaurantData();
    const { t } = useTranslation();
    const ref = useRef<HTMLDivElement | null>(null);
    const box = useRef<HTMLDivElement | null>(null);
    const button = useRef<HTMLDivElement | null>(null);
    const cartAdderRef = useRef<CartAdderRef>(null);
    useEffect(() => {
        const localRef = ref.current;
        function handleScroll() {
            if (!button.current || !ref.current || !box.current) {
                return;
            }
            const localRef = ref.current;
            const scrolledToBottom =
                (localRef?.offsetHeight || 0) + ((localRef?.scrollTop || 0) + 0.5) >= (localRef?.scrollHeight || 0);
            console.log(localRef?.offsetHeight, localRef?.scrollTop, localRef?.scrollHeight, (localRef?.offsetHeight || 0) + ((localRef?.scrollTop || 0) + 0.5), (localRef?.offsetHeight || 0) + ((localRef?.scrollTop || 0) + 0.5) >= (localRef?.scrollHeight || 0));
            console.log(moveButton, oldHeight, isScrolledToBottom, button.current?.children[0].clientHeight);
            // +0.5 on scrollTop is because the value is a double and it won't be enough when added to offsetheight to know that it is at bottom scrolled
            // +16 on button is because 1rem margin bottom
            const moveButtonTemp = (localRef?.offsetHeight || 0) + ((localRef?.scrollTop || 0) + 0.5) + ((box.current?.clientHeight || 0) - (!moveButton ? (button.current?.children[0].clientHeight || 0) + 16 : 0)) >= (localRef?.scrollHeight || 0);

            setMoveButton(moveButtonTemp);
            setOldHeight(ref.current?.scrollHeight || 0);
            setIsScrolledToBottom(scrolledToBottom);
            console.log('isBottom  ' + scrolledToBottom);
            console.log('moveButtonTemp  ' + moveButtonTemp);
        }

        localRef?.addEventListener("scroll", handleScroll);

        return () => {
            localRef?.removeEventListener("scroll", handleScroll);
        };
    }, [isScrolledToBottom, moveButton, oldHeight]);

    useEffect(() => {
            const localRef = ref.current;
            const scrolledToBottom =
                (localRef?.offsetHeight || 0) + ((localRef?.scrollTop || 0) + 0.5) >= (localRef?.scrollHeight || 0);
            console.log(localRef?.offsetHeight, localRef?.scrollTop, localRef?.scrollHeight, (localRef?.offsetHeight || 0) + ((localRef?.scrollTop || 0) + 0.5), (localRef?.offsetHeight || 0) + ((localRef?.scrollTop || 0) + 0.5) >= (localRef?.scrollHeight || 0));
            console.log(moveButton, oldHeight, isScrolledToBottom, button.current?.children[0].clientHeight);
            // +0.5 on scrollTop is because the value is a double and it won't be enough when added to offsetheight to know that it is at bottom scrolled
            // +16 on button is because 1rem margin bottom
            const moveButtonTemp = (localRef?.offsetHeight || 0) + ((localRef?.scrollTop || 0) + 0.5) + ((box.current?.clientHeight || 0) - (!moveButton ? (button.current?.children[0].clientHeight || 0) + 16 : 0)) >= (localRef?.scrollHeight || 0);
            setMoveButton(!moveButtonTemp||scrolledToBottom);
            //setOldHeight(ref.current?.scrollHeight || 0);
            setIsScrolledToBottom(scrolledToBottom);
            console.log('isBottom  ' + scrolledToBottom);
            console.log('moveButtonTemp  ' + moveButtonTemp);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [item]);

    const handleClickAddCart = () => {
        if (!cartAdderRef.current) {
            return;
        }
        cartAdderRef.current.executeClick();
    }

    return (
        <Box
            display="flex"
            justifyContent={center ? "center" : ""}
            alignItems={center ? "center" : ""}
            flexDirection='column'
            style={{
                flex: '1',
                width: '100vw',
                minHeight: '100%',
                ...style
            }}
        >
            <Box ref={ref} sx={{ display: 'flex', flexDirection: 'column', height: '100%', minWidth: '100%', overflowX: 'hidden' }}>
                <Container className='container' maxWidth={!maxWidth ? false : "sm"} style={{ height: '100%' }} disableGutters={!maxWidth}>
                    <Box className='container' sx={{ minHeight: '100%', minWidth: '100%', maxWidth: '100%', display: 'flex', flexDirection: 'column' }}>
                        <div className='content'>
                            {children}
                        </div>
                        <Box sx={{ flexGrow: 2 }} />
                        {item && license.licenseType !== 'Standard' && qrMenuProperties?.dofEnabled && !live && (table > 0 || token.length > 0) && !(sessionId.length > 0 && expired.getTime() < Date.now()) &&
                            <Box ref={button} display="flex" alignItems="center" justifyContent="center">
                                <Fab onClick={handleClickAddCart} color="primary" aria-label="add" variant="extended" size="large" style={{ boxShadow: "0rem 0rem 0.2rem rgb(255, 40, 40)", position: !moveButton ? "fixed" : 'unset', bottom: "2rem", marginBottom: moveButton ? '1rem' : 0 }}>
                                    <CartAdder ref={cartAdderRef} item={item} />
                                    {t('addToBag')}
                                </Fab>
                            </Box>}
                        <Box ref={box} sx={{ backgroundColor: 'rgb(37,37,37)', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', m: '0 -200%' }}>
                            <Typography variant='caption' sx={{
                                textAlign: 'center',
                                color: 'white',
                                padding: '0.3rem',
                                mt: '0.8rem',
                                display: 'inline-block',
                                whiteSpace: 'pre-line',
                                maxWidth: '100vw'
                            }}>
                                {t('bottomLineInfo')}
                            </Typography>
                            <Typography variant='caption' sx={{
                                textAlign: 'center',
                                color: 'white',
                                padding: '0.3rem',
                                display: 'inline-block'
                            }}>
                                <Link component={RouterLink} to={`/qr-menu/${params.restaurantId}/imprint`} sx={{ mr: '1rem' }}>
                                    {`${t('imprint')}`}
                                </Link>
                                <Link component={RouterLink} to={`/qr-menu/${params.restaurantId}/privacy-policy`}>
                                    {`${t('privacyPolicy')}`}
                                </Link>
                            </Typography>
                        </Box>
                    </Box>
                </Container>
            </Box>
        </Box >
    );
}